import HttpRequest from "../../utilities/httpRequest";
import {
  hideLoader,
  showLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";
import {
  addMedicine,
  addMedicineFailure,
  addMedicineRequest,
  fetchMedicines,
  fetchMedicinesFailure,
  fetchMedicinesRequest,
  searchMedicinesFailure,
  searchMedicinesRequest,
  searchMedicinesSuccess,
  toggleMedicineStatus,
  toggleMedicineStatusFailure,
  toggleMedicineStatusRequest,
  updateMedicine,
  updateMedicineFailure,
  updateMedicineRequest,
} from "./medicineActions";

const API_BASE = `medicineInventory`;

const getErrorMessage = (error) => {
  if (error.response?.data?.error) return error.response.data.error;
  if (error.message) return error.message;
  return "Something went wrong";
};

/**
 * Fetch all medicines
 */
export const fetchMedicinesApi = () => {
  return (dispatch) => {
    dispatch(fetchMedicinesRequest());
    dispatch(showLoader());

    return new HttpRequest(dispatch, API_BASE, "get")
      .send()
      .then((res) => {
        dispatch(hideLoader());
        dispatch(fetchMedicines(res.data.data));
        return Promise.resolve(res.data.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        const errMsg = getErrorMessage(error);
        dispatch(fetchMedicinesFailure(errMsg));
        dispatch(showSnackbar(errMsg, "error"));
        return Promise.reject(error);
      });
  };
};

/**
 * Add new medicine
 */
export const addMedicineApi = (medicineData) => {
  return (dispatch) => {
    dispatch(addMedicineRequest());
    // dispatch(showLoader());

    return new HttpRequest(dispatch, API_BASE, "post", medicineData)
      .send()
      .then((res) => {
        dispatch(hideLoader());
        dispatch(addMedicine(res.data.data));
        dispatch(showSnackbar("Medicine added successfully", "success"));
        return Promise.resolve(res.data.data);
      })
      .catch((error) => {
        console.error("API error:", error);

        // dispatch(hideLoader());
        const errMsg = getErrorMessage(error);
        dispatch(addMedicineFailure(errMsg));
        dispatch(showSnackbar(errMsg, "error"));
        return Promise.reject(error);
      });
  };
};

/**
 * Update medicine
 */
export const updateMedicineApi = (id, medicineData) => {
  return (dispatch) => {
    dispatch(updateMedicineRequest());
    const url = `${API_BASE}/${id}`;
    return new HttpRequest(dispatch, url, "put", medicineData)
      .send()
      .then((res) => {
        dispatch(updateMedicine(res.data.data));
        dispatch(showSnackbar("Medicine updated successfully", "success"));
        return Promise.resolve(res.data.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        const errMsg = getErrorMessage(error);
        dispatch(updateMedicineFailure(errMsg));
        dispatch(showSnackbar(errMsg, "error"));
        return Promise.reject(error);
      });
  };
};

/**
 * Toggle medicine active/inactive status
 */
export const toggleMedicineStatusApi = (id, active) => {
  return (dispatch) => {
    dispatch(toggleMedicineStatusRequest());
    // dispatch(showLoader());

    const url = `${API_BASE}/${id}/active`;

    return new HttpRequest(dispatch, url, "put", { active })
      .send()
      .then((res) => {
        // dispatch(hideLoader());

        dispatch(toggleMedicineStatus(res.data.data));
        dispatch(
          showSnackbar(
            `Medicine ${active ? "enabled" : "disabled"} successfully`,
            "success"
          )
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch(hideLoader());
        const errMsg = getErrorMessage(error);
        dispatch(toggleMedicineStatusFailure(errMsg));
        dispatch(showSnackbar(errMsg, "error"));
        return Promise.reject(error);
      });
  };
};

/**
 * Search medicines
 */
// export const searchMedicinesApi = (medicineName) => {
//   return (dispatch) => {
//     dispatch(searchMedicinesRequest());

//     const url = `${API_BASE}?medicineName=${encodeURIComponent(medicineName)}`;

//     return new HttpRequest(dispatch, url, "get")
//       .send()
//       .then((res) => {
//         dispatch(searchMedicinesSuccess(res.data.data));
//         return res.data.data;
//       })
//       .catch((error) => {
//         dispatch(hideLoader());
//         const errMsg = getErrorMessage(error);
//         dispatch(searchMedicinesFailure(errMsg));
//         dispatch(showSnackbar(errMsg, "error"));
//         return Promise.reject(error);
//       });
//   };
// };

export const searchMedicinesApi = (query) => {
  return (dispatch, getState) => {
    dispatch(searchMedicinesRequest());
    const { allMedicines } = getState().medicine;

    try {
      // For empty query or small dataset, use local filtering
      if (!query.trim() || allMedicines.length < 100) {
        const results = !query.trim()
          ? allMedicines
          : allMedicines.filter((m) =>
              m.medicineName.toLowerCase().includes(query.toLowerCase())
            );
        dispatch(searchMedicinesSuccess(results, query));
        return Promise.resolve(results);
      }

      // For larger datasets, call API
      const url = `${API_BASE}?medicineName_like=${encodeURIComponent(query)}`;
      return new HttpRequest(dispatch, url, "get").send().then((res) => {
        dispatch(searchMedicinesSuccess(res.data.data, query));
        return res.data.data;
      });
    } catch (error) {
      dispatch(searchMedicinesFailure(error.message));
      return Promise.reject(error);
    }
  };
};
